import React, { useCallback, useRef } from "react";
import { useFormContext } from "react-hook-form";

//
export default function TitleTextArea(props: any): JSX.Element {
	const { register } = useFormContext();
	const textareaRef = useRef<HTMLTextAreaElement | null>(null);

	/**
	 * 자동스클롤
	 * @param {*} e
	 */

	const handleKeyEvent = useCallback((e) => {
		setTimeout(() => {
			if (textareaRef.current) {
				textareaRef.current.style.height = "auto";
				textareaRef.current.style.height = textareaRef.current.scrollHeight + "px";
			}
		}, 0);

		//엔터키막기
		if (e.keyCode === 13) {
			e.stopPropagation();
			e.preventDefault();
		}
	}, []);

	return (
		<textarea
			ref={(ref: HTMLTextAreaElement) => {
				register(ref);
				textareaRef.current = ref; // you can still assign to ref
			}}
			{...props}
			onKeyDown={handleKeyEvent}
			onKeyUp={handleKeyEvent}
		></textarea>
	);
}
